// -------------详情页js----------------

// -----------------隐藏详情页大视频的下载按钮-------------------
document.querySelectorAll('.tabs-wrapper .card_videodeop').forEach(video => {
  video.setAttribute('controlslist', 'nodownload');
});
// ----------------------------------↑--------------------------------------- 



// ----------------------详情页嵌入小视频----------------------
// function toggleEmbed() {
//   const embeds = document.querySelectorAll('#section-firework-embed');

//   if (!embeds.length) return;

//   embeds.forEach(el => el.style.display = 'none');

//   if (window.innerWidth >= 768) {
//     if (embeds[1]) embeds[1].style.display = '';
//   } else {
//     if (embeds[0]) embeds[0].style.display = '';
//   }
// }

// document.addEventListener('DOMContentLoaded', toggleEmbed);
// 窗口大小变化时也执行
// window.addEventListener('resize', toggleEmbed);


// ----------------------------------↑--------------------------------------- 


